import { makeStyles } from "@material-ui/core";

export const vendorFeedbackStyle = makeStyles({
    container: {
        padding: '1em 2em',
    },
    ratingNumber: {
        fontSize: '0.8em'
    },
    description: {
        fontSize: '0.9em',
        color: 'gray',
        marginTop: '1em',
    },
    scaleDescription: {
        fontSize: '0.9em',
        color: 'gray',
        marginBottom: '1em',
    },
    feedbackTypeLabel: {
        fontWeight: 'bold',
        marginTop: '1em',
    },
    saveButton: {
        marginTop: '1em',
        margin: '0 auto'
    },
    subTitle: {
        color: 'gray',
        fontWeight: 'normal',
        fontSize: '0.9em',
        marginTop: '-0.5em',
    },
    sliderText: {
        fontSize: '0.8em',
        color: 'gray',
        marginTop: '-2em',
        // '&.left': {
        //     marginLeft: '0.5em',
        // },
        // '&.right': {
        //     marginRight: '-0.5em',
        // }
    },
    left: {
        marginLeft: '2.5em',
    },
    right: {
        marginRight: '5em',
    },
    card: {
        padding: '1em 2em',
        height: '100%',
        boxShadow: '2px 3px 10px #d7d6d6',
        position: 'relative',
        overflowY: 'auto'
    }
})